import React, { useState, useEffect, useCallback } from "react";
import { Table, Spin, Tag } from "antd";
import moment from "moment";
import { getLoginHistory } from "../../core/api/settings";

const LoginHistory = () => {
  const [loginData, setLoginData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadLoginHistory = useCallback(async () => {
    setLoading(true);
    try {

      const response = await getLoginHistory();
      setLoginData(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error loading login history:", err);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadLoginHistory();
  }, [loadLoginHistory]);

  const columns = [
    {
      title: "User",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Login Time",
      dataIndex: "login_time",
      key: "login_time",
      sorter: (a, b) => new Date(a.login_time) - new Date(b.login_time),
      render: (login_time) => (
        <span>{moment(login_time).format("MMM DD, YYYY h:mm A")}</span>
      ),
    },
    {
      title: "Location",
      dataIndex: "location_info",
      key: "location_info",
      render: (location_info) => {
        try {
          if (!location_info) return "-";
          const locationData = typeof location_info === 'string' ? 
            JSON.parse(location_info) : location_info;
          return (
            <span>
              {locationData.city}, {locationData.country}
            </span>
          );
        } catch (e) {
          return "-";
        }
      },
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Success" ? "green" : "red"}>
          {status}
        </Tag>
      ),
    },
  ];

  return (
    <div className=" ">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Login History</h4>
            <h6>View all login attempts</h6>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
      

            <div className="table-responsive">
              {loading ? (
                <div className="text-center p-4">
                  <Spin size="large" />
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={loginData}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginHistory;
